// Central company / group information for SARVODAYA GROUP.
// Source: SARVODAYA GROUP company profile document.
// Edit here only -- every page reads from this file.
// Bank accounts and payment QRs are NOT here: they are customer-only and
// live in components/customer/accountInfoData.js (Account Info screen).

import sarvodayaLogo from './assets/images/sarvodaya-logo.png';
import vetremLogo from './assets/images/vetrem-logo.png';

export const GROUP = {
    name: 'SARVODAYA GROUP',
    shortName: 'Sarvodaya Group',
    tagline: 'Pharmaceutical Distributor',
    since: 'Since 1999',
    logo: sarvodayaLogo,
    email: 'sarvodaya.agencies.udupi@gmail.com',
    website: 'sarvodayagroup.in',
    playStore:
        'https://play.google.com/store/apps/details?id=in.relysoft.sarvodayagroup&hl=en',
};

// The software vendor's support desk - shown in every footer.
export const SUPPORT = {
    name: 'Reliable Software',
    place: 'Goa',
    url: 'https://relysoft.in/',
    // WhatsApp support. The display form carries the leading 0 people dial
    // locally; the link uses the country code so it works from anywhere.
    whatsapp: '9422063290',
    whatsappDisplay: '094220 63290',
    // landline / service number
    landline: '9890633394',
    landlineDisplay: '098906 33394',
    countryCode: '91',
};

export const BRAND = {
    green: '#00A759',
    greenDark: '#008C4A',
    purple: '#3C2B99',
    purpleDark: '#2E2077',
    light: '#E8F7EF',
};

export const DIVISIONS = [
    {
        key: 'sarvodaya-ho',
        name: 'SARVODAYA AGENCIES',
        label: 'Head Office',
        logo: sarvodayaLogo,
        addressLines: [
            'Shree Vasanthi, Ground Floor, D.No. 4-2-71E(1)',
            '& First Floor, D.No. 4-2-71E(3), Beedu Compound',
            'Nairkere Road, Ambalpady, Udupi - 576103',
        ],
        city: 'Udupi',
        state: 'Karnataka',
        pincode: '576103',
        phones: ['0820-2532525', '0820-2533325', '9343183325', '9343163325'],
        // what Contact Us drops into the Google Maps embed for this office
        mapQuery:
            'Sarvodaya Agencies, Nairkere Road, Ambalpady, Udupi, Karnataka 576103',
        email: 'sarvodaya.agencies.udupi@gmail.com',
        gst: '29AAKPH5849L1Z0',
        drugLicences: ['KA-UD1-20B-135265', 'KA-UD1-21B-135266'],
    },
    {
        key: 'sarvodaya-shimoga',
        name: 'SARVODAYA AGENCIES',
        label: 'Shimoga Branch',
        logo: sarvodayaLogo,
        addressLines: [
            'Panchavatti Building, 1st Floor',
            'Near Modern Talkies, B H Road',
            'Shimoga - 577201',
        ],
        city: 'Shimoga',
        state: 'Karnataka',
        pincode: '577201',
        phones: ['9342213325'],
        mapQuery:
            '13.929442646721947, 75.572611',
        email: 'sarvodayashimoga@gmail.com',
        gst: '29AAKPH5849L1Z0',
        drugLicences: ['KA/SMG 20B-522', 'KA/SMG 21B-487'],
    },
    {
        key: 'vetrem-pharma',
        name: 'VETREM PHARMA',
        label: 'Group Company',
        logo: vetremLogo,
        // Vetrem is at 4-2-71D, not the Shree Vasanthi block next door - the
        // two were previously listed at the same address.
        addressLines: [
            'D.No. 4-2-71D, Beedu Compound',
            'Nairkere Road, Ambalpady, Udupi - 576103',
        ],
        city: 'Udupi',
        state: 'Karnataka',
        pincode: '576103',
        phones: ['9845513325', '9343183325'],
        mapQuery:
            'Vetrem Pharma, 4-2-71D, Beedu Compound, Nairkere Road, Ambalpady, Udupi, Karnataka 576103',
        email: 'vetrempharma1@gmail.com',
        gst: '29AARFV4197N1ZX',
        drugLicences: ['20B-KA-UD1-183866', '21B-KA-UD1-183867'],
    },
];

// The division used for site-wide footer / header defaults.
export const PRIMARY = DIVISIONS[0];

export default GROUP;
